import { gql } from '@apollo/client';

const EXTEND_USER_SESSION = gql`
  {
    extendUserSession
  }
`;

export default EXTEND_USER_SESSION;
